import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import { Route, Switch, Router } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core";
import { history, errorPageService, StoreProvider, logOutAction, } from "ftl-dashboards-core";
import { FTLLoader, FTLErrorBoundary, DialogContainer, ErrorContainer, SnackbarContainer, } from "ftl-dashboards-ui-kit";
import FTLAuthPage from "./FTLAuthPage";
import FTLBaseLayout from "./FTLBaseLayout";
export default ({ 
/**
 * Название проекта, например Tech Admin
 */
project, AuthRepository, 
/**
 * Свойства StoreProvider из модуля core
 */
StoreProviderProps, 
/**
 * Свойства FTLBaseLayout из модуля шаблонов
 */
BaseLayoutProps, 
/**
 * Здесь нужно передать роуты проекта
 */
children, redirectOnAuthUrl, toHomeUrl = redirectOnAuthUrl, theme, }) => {
    var _a, _b;
    const projectTitles = typeof project.title === "string"
        ? {
            authPage: `Войти в ${project.title}`,
            header: project.title,
        }
        : project.title;
    return (_jsxs(ThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(CssBaseline, {}, void 0),
            _jsx(Router, Object.assign({ history: history }, { children: _jsxs(StoreProvider, Object.assign({}, StoreProviderProps, { children: [_jsx(CssBaseline, {}, void 0),
                        _jsxs(Switch, { children: [_jsx(Route, Object.assign({ exact: true, path: "/" }, { children: _jsx(FTLErrorBoundary, Object.assign({ location: history.location, fullScreen: true }, { children: _jsxs(ErrorContainer, Object.assign({ fullScreen: true }, { children: [_jsx(FTLAuthPage, { AuthRepository: AuthRepository, redirectOnAuthUrl: redirectOnAuthUrl, title: projectTitles.authPage, logo: (_a = project.logo) === null || _a === void 0 ? void 0 : _a.authPage }, void 0),
                                                _jsx(SnackbarContainer, {}, void 0),
                                                _jsx(DialogContainer, {}, void 0)] }), void 0) }), void 0) }), void 0),
                                _jsx(Route, { children: _jsx(FTLBaseLayout, Object.assign({ AuthRepository: AuthRepository, toHomeUrl: toHomeUrl, title: projectTitles.header, onSignOut: () => StoreProviderProps.store.dispatch(logOutAction), logo: (_b = project.logo) === null || _b === void 0 ? void 0 : _b.header }, BaseLayoutProps, { children: _jsx(FTLErrorBoundary, Object.assign({ location: history.location }, { children: _jsx(ErrorContainer, Object.assign({ service: errorPageService, basePath: toHomeUrl }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx(FTLLoader, { height: "50vh", color: "dark" }, void 0) }, { children: children }), void 0) }), void 0) }), void 0) }), void 0) }, void 0)] }, void 0)] }), void 0) }), void 0)] }), void 0));
};
//# sourceMappingURL=UIMain.js.map